import { useState } from "react";
import {
  MotionFlex,
  MotionBox,
  menuItemAppearRight,
  menuItemAppearLeft,
} from "utils/motion";
import { Box } from "@chakra-ui/react";
import LanguageSelector from "components/blocks/LanguageSelector";
import ArrowIcon from "components/icons/ArrowIcon";
import Button from "components/base/Button";
import Trans from "components/base/Trans";

import navbarContent from "utils/navbar.json";

const NavbarMobileMenu = ({ onClose, slide, onAction, onAccountClick }) => {
  const [isOnSubMenu, setIsOnSubMenu] = useState(false);
  return (
    <MotionBox
      pt="100px"
      pb="xxl"
      px="lg"
      h="100vh"
      display={["flex", null, "none"]}
      position="relative"
    >
      <MotionFlex
        w="100%"
        direction="column"
        alignItems="flex-start"
        variants={menuItemAppearLeft}
        initial="visible"
        animate={isOnSubMenu ? "hidden" : "visible"}
      >
        {navbarContent.map((item, idx) => (
          <Button
            key={item.id}
            id={item.id}
            opacity={1}
            mb="lg"
            _focus={{ boxShadow: "0 0 0" }}
            variant="menu"
            href={item.id === "hc50" ? item.url : null}
            onClick={
              item.id !== "hc50"
                ? () => {
                    setIsOnSubMenu(true);
                    onAction(idx);
                  }
                : null
            }
          >
            <Trans id={item.label} />
          </Button>
        ))}
        <Button
          id="configurator"
          href="/configurator/0"
          size="small"
          variant="outline"
          _focus={{ boxShadow: "0 0 0" }}
          height="42px"
          mb="xl"
        >
          <Trans id="LBL_CONFIGURATOR" />
        </Button>
        <Box w="100%" h="1px" bg="whiteAlpha.400" mb="xl" />
        <Button
          id="account"
          opacity={1}
          mb="md"
          _focus={{ boxShadow: "0 0 0" }}
          variant="menu"
          small
          onClick={onAccountClick}
        >
          <Trans id="LBL_ACCOUNT" />
        </Button>
        <MotionFlex>
          <LanguageSelector />
        </MotionFlex>
      </MotionFlex>
      <MotionFlex
        direction="column"
        alignItems="flex-start"
        variants={menuItemAppearRight}
        position="absolute"
        left="0"
        right="0"
        px="lg"
        initial="hidden"
        animate={isOnSubMenu ? "visible" : "hidden"}
        style={{ overflow: "auto" }}
        h="85vh"
      >
        <Button
          opacity={1}
          mb="xl"
          ml="-8px"
          _focus={{ boxShadow: "0 0 0" }}
          fontWeight="normal"
          variant="menu"
          small
          onClick={() => setIsOnSubMenu(false)}
        >
          <ArrowIcon bg="silver" />
          <Trans id="LBL_BACK" />
        </Button>
        {navbarContent[slide].items.map((item) => (
          <Button
            key={item.id}
            id={item.id}
            href={item.url}
            opacity={1}
            mb="md"
            _focus={{ boxShadow: "0 0 0" }}
            variant="menu"
            onClick={() => {
              setIsOnSubMenu(false);
              onClose();
            }}
          >
            <Trans id={item.label} />
          </Button>
        ))}
        {navbarContent[slide].subItems?.length > 0 && (
          <>
            <Box w="100%" h="1px" bg="whiteAlpha.400" my="xl" />
            {navbarContent[slide].subItems.map((item) => (
              <Button
                key={item.id}
                id={item.id}
                href={item.url}
                opacity={1}
                mb="md"
                _focus={{ boxShadow: "0 0 0" }}
                variant="menu"
                small
                onClick={() => {
                  setIsOnSubMenu(false);
                  onClose();
                }}
              >
                <Trans id={item.label} />
              </Button>
            ))}
          </>
        )}
      </MotionFlex>
    </MotionBox>
  );
};

export default NavbarMobileMenu;
